export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full">
            <div className="relative w-[260px] h-[520px] md:w-[300px] md:h-[580px] mx-auto rounded-3xl overflow-hidden bg-background-200 border-4 border-background-300">
              <img
                src="https://readdy.ai/api/search-image?query=Smartphone%20mobile%20app%20mockup%20showing%20manga%20comic%20reading%20interface%2C%20colorful%20manga%20cover%20grid%20display%2C%20clean%20modern%20UI%20with%20warm%20orange%20accents%2C%20Japanese%20Korean%20comic%20style%20thumbnails%2C%20digital%20reading%20platform%2C%20sleek%20phone%20frame%2C%20soft%20warm%20lighting%2C%20professional%20app%20screenshot%20presentation&width=600&height=1160&seq=app-mockup-manga&orientation=portrait"
                alt="蛙漫漫画APP移动端阅读界面展示"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-4 whitespace-nowrap">
              APP下载
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
              随时随地，畅享漫画
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-4 leading-relaxed max-w-[500px] mx-auto lg:mx-0">
              蛙漫漫画APP已上架各大应用商店，支持iOS和Android双平台。
              流畅的阅读体验、智能缓存、夜间模式、个性化推荐，
              让你随时随地沉浸在漫画的世界中。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-6">
              <div className="flex items-center gap-2 px-5 py-3 rounded-xl bg-foreground-900 text-white cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-apple-fill text-xl"></i>
                <div className="text-left">
                  <div className="text-[10px] leading-none opacity-70">Download on the</div>
                  <div className="text-sm font-semibold leading-tight">App Store</div>
                </div>
              </div>
              <div className="flex items-center gap-2 px-5 py-3 rounded-xl bg-foreground-900 text-white cursor-pointer hover:bg-foreground-800 transition-colors">
                <i className="ri-google-play-fill text-xl"></i>
                <div className="text-left">
                  <div className="text-[10px] leading-none opacity-70">GET IT ON</div>
                  <div className="text-sm font-semibold leading-tight">Google Play</div>
                </div>
              </div>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-5 mt-6 flex-wrap">
              <div className="flex items-center gap-1.5">
                <i className="ri-star-fill text-amber-400 text-sm"></i>
                <span className="text-sm text-foreground-600">4.9分</span>
              </div>
              <div className="w-px h-4 bg-background-300"></div>
              <span className="text-sm text-foreground-600">500万+ 下载</span>
              <div className="w-px h-4 bg-background-300"></div>
              <span className="text-sm text-foreground-600">安全无广告</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}